import { ActionFunction } from 'react-router-dom'

import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import ErrorEmitter from '@utils/emitters/ErrorEmitter'
import http from '@utils/http'
import i18n from '@utils/i18n'

const restoreScoresAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const externalIds = formDataToArray(formData.get('scoreIds'))

  if (!externalIds.length) {
    return null
  }

  const resp = await http.action.post<RestoreScoresResponse>(
    ApiRoutes.members.restoreScoresPath(),
    {
      score_ids: externalIds,
    }
  )

  const numFailed = (resp as RestoreScoresResponse).failed?.length
  if (numFailed) {
    ErrorEmitter.addError({ message: i18n.t('errors.unableToRestore', { count: numFailed }) })
  }

  return resp
}

export default restoreScoresAction

export type RestoreScoresResponse = {
  failed: string[]
  scores: string[]
}
